import { createContext } from 'react';

export const ModalContext = createContext({
  opened: false,
  // eslint-disable-next-line
  changeModalState: (opened: boolean) => {},
});
